/**
 * Opens the Olark live chat widget, loading Olark on the first call.
 *
 * Olark is not loaded with the page (about 1.6 MB of script), so every entry
 * point in the theme (footer CTA, contact method cards, the global floating
 * chat button) calls this function. On the first call it injects the official
 * Olark loader with the site ID from snippets/olark-chat.liquid; the loader
 * queues `api.box.expand` and runs it once the widget has booted.
 *
 * @returns {boolean} True when the widget was opened or is opening.
 */
const loadOlark = () => {
  const siteId = document.querySelector('[data-olark-site-id]')?.dataset.olarkSiteId

  if (!siteId) return false

  ;(function (o, l, a, r, k, y) {
    if (o.olark) return
    r = 'script'; y = l.createElement(r); r = l.getElementsByTagName(r)[0]
    y.async = 1; y.src = '//' + a; r.parentNode.insertBefore(y, r)
    y = o.olark = function () { k.s.push(arguments); k.t.push(+new Date()) }
    y.extend = function (i, j) { y('extend', i, j) }
    y.identify = function (i) { y('identify', k.i = i) }
    y.configure = function (i, j) { y('configure', i, j); k.c[i] = j }
    k = y._ = { s: [], t: [+new Date()], c: {}, l: a }
  })(window, document, 'static.olark.com/jsclient/loader.js')

  window.olark.identify(siteId)

  return true
}

export default () => {
  if (typeof window.olark !== 'function' && !loadOlark()) return false

  window.olark('api.box.expand')

  return true
}
